/**
 * Newsletter Popup logic
 * Mostra il popup in base al cookie (personalizzabile tramite editor)
 */

class NewsletterPopup {
  constructor() {
    this.popup = document.getElementById('newsletter-popup');
    if (!this.popup) return;

    this.closeButton = this.popup.querySelector('[data-newsletter-popup="close"]');
    this.backdrop = document.getElementById('backdrop-darker');

    this.cookieName = 'newsletter_popup_shown';
    this.cookieDuration = parseInt(this.popup.dataset.cookieDuration) || 30;
    this.delaySeconds = parseInt(this.popup.dataset.delaySeconds) || 5;
    this.isEnabled = this.popup.dataset.enabled === 'true';

    this.init();
  }
  init() {

    if (!this.isEnabled || this.getCookie(this.cookieName)) {
      return;
    }

    this.showPopupWithDelay();


    if (this.closeButton) {
      this.closeButton.addEventListener('click', () => this.closePopup());
    }

    document.addEventListener('overlay:closeAll', () => this.closePopup());

    const form = this.popup.querySelector('.newsletter-form');
    if (form) {

      const urlParams = new URLSearchParams(window.location.search);
      if (urlParams.has('customer_posted') && urlParams.get('customer_posted') === 'true') {

        this.setCookie(this.cookieName, 'true', this.cookieDuration * 2);
      }
    }
  }

  showPopupWithDelay() {

    setTimeout(() => {
      this.popup.classList.add('active');
      document.dispatchEvent(new CustomEvent('overlay:open', { detail: { id: 'newsletter-popup' } }));
      this.setCookie(this.cookieName, 'true', this.cookieDuration);
    }, this.delaySeconds * 1000);
  }

  closePopup() {
    this.popup.classList.remove('active');
    document.dispatchEvent(new CustomEvent('overlay:close', { detail: { id: 'newsletter-popup' } }));
  }

  setCookie(name, value, days) {
    const date = new Date();
    date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
    const expires = "; expires=" + date.toUTCString();
    document.cookie = name + "=" + (value || "") + expires + "; path=/";
  }

  getCookie(name) {
    const nameEQ = name + "=";
    const ca = document.cookie.split(';');
    for (let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) === ' ') c = c.substring(1, c.length);
      if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
    }
    return null;
  }
}

new NewsletterPopup();
